import { EntityTabs } from '../../../constants/entity-tabs';

export const CreateEntityRoutes = {
  [EntityTabs.Accommodation]: '/accommodations/create',
  [EntityTabs.Activities]: '/activities/create',
  [EntityTabs.Rental]: 'rental-items/create'
};

export const CreateButtonContent = {
  [EntityTabs.Accommodation]: 'New Accommodation',
  [EntityTabs.Activities]: 'New Activity',
  [EntityTabs.Rental]: 'New Rental Items'
};
